import React from 'react'

import { ReactComponent as SetaIcon } from '../../assets/Vector.svg'
import SendGTAGEvent from '../../utils/sendGTAGEvent'

import { Container } from './styles'

interface iButtonProps {
  isVisible: boolean,
  color: string,
  backgroundColor?: string,
  borderRadius?: string,
}


const ButtonTop: React.FC<iButtonProps> = ({ isVisible, color, backgroundColor, borderRadius }) => (
  <Container color={color} isVisible={isVisible} href="#" backgroundColor={backgroundColor} borderRadius={borderRadius}
    onClick={() => {
      SendGTAGEvent(
        'botao_seta_topo',
        'Navegação',
        'Usuário clicou em "Topo"',
      )
    }}
  >
    <SetaIcon className='iconSvg' />
    Topo
  </Container>
)


export default ButtonTop